import * as React from 'react';

import MediaQuery from 'react-responsive';
import { ConnectedTransitionDesktop } from './transition-desktop';
import { ConnectedTransitionMobile } from './transition-mobile';

interface IExternalProps {
    mediaWidth: string;
}

type ResponsiveProps = IExternalProps;

export let Responsive: React.StatelessComponent<ResponsiveProps> = props => {
    return (
        <>
            <MediaQuery query={`not all and (max-width: ${props.mediaWidth})`}>
                <ConnectedTransitionDesktop />
            </MediaQuery>

            <MediaQuery query={`all and (max-width: ${props.mediaWidth})`}>
                <ConnectedTransitionMobile />
            </MediaQuery>
        </>
    )
}